import "antd/es/checkbox/style";
import _Checkbox from "antd/es/checkbox";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["options", "fieldProps", "proFieldProps", "valueEnum"];
import React from 'react';
import ProFormField from '../Field';
import { runFunction } from '@ant-design/pro-utils';
import { createField } from '../../BaseForm/createField';
var CheckboxGroup = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var options = _ref.options,
      fieldProps = _ref.fieldProps,
      proFieldProps = _ref.proFieldProps,
      valueEnum = _ref.valueEnum,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ProFormField, _extends({
    ref: ref,
    valueType: "checkbox",
    mode: "edit",
    valueEnum: runFunction(valueEnum, undefined),
    fieldProps: _objectSpread({
      options: options
    }, fieldProps),
    proFieldProps: proFieldProps
  }, rest));
});
/**
 * 多选框的
 *
 * @param
 */

var ProFormCheckboxComponents = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var fieldProps = _ref2.fieldProps,
      children = _ref2.children;
  return /*#__PURE__*/React.createElement(_Checkbox, _extends({
    ref: ref
  }, fieldProps), children);
});
var ProFormCheckbox = createField(ProFormCheckboxComponents, {
  valuePropName: 'checked'
});
var WrappedProFormCheckbox = ProFormCheckbox;
WrappedProFormCheckbox.Group = CheckboxGroup;
export default WrappedProFormCheckbox;